import { useNavigate } from "react-router-dom";
import { ClipboardCheck, PhoneCall } from "lucide-react";
import { timeAgo } from "@/lib/format";
import SectionCard, { ViewAllLink } from "./SectionCard";

const ICON = { followup_due: PhoneCall, quotation_approval: ClipboardCheck };
const LABEL = { followup_due: "Follow-up call", quotation_approval: "Approve quotation" };

// There is no calendar/task model yet, so this shows the oldest waiting
// follow-ups and approvals from the attention feed instead of a real schedule.
export default function FollowUpQueue({ items }) {
  const navigate = useNavigate();
  const queue = items
    .filter((i) => ICON[i.type])
    .sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp))
    .slice(0, 5);

  if (queue.length === 0) return null;

  return (
    <SectionCard testId="follow-up-queue" title="Waiting on you" action={<ViewAllLink to="/enquiries" />}>
      <ol className="relative">
        {queue.map((item, idx) => {
          const Icon = ICON[item.type];
          return (
            <li key={item.id} className="relative flex items-start gap-3 pb-4 last:pb-0">
              {idx < queue.length - 1 && (
                <span className="absolute left-[3px] top-3 bottom-0 w-px bg-border" aria-hidden="true" />
              )}
              <span className="relative mt-1.5 h-[7px] w-[7px] rounded-full bg-warning shrink-0" />
              <span className="w-16 shrink-0 text-xs text-muted-foreground mt-0.5 tabular-nums">{timeAgo(item.timestamp)}</span>
              <button
                onClick={() => navigate(item.actionUrl)}
                className="flex-1 min-w-0 flex items-start gap-2 text-left border-b border-border pb-3 group"
              >
                <Icon className="h-4 w-4 text-muted-foreground shrink-0 mt-0.5" strokeWidth={1.75} />
                <span className="text-sm text-foreground group-hover:text-primary truncate">
                  <span className="font-medium">{LABEL[item.type]}</span> – {item.subtitle}
                </span>
              </button>
            </li>
          );
        })}
      </ol>
    </SectionCard>
  );
}
